// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"279":"d0b70561","292":"d90a65bf","871":"afbae0bc","874":"1e1600fe"}[chunkId] + ".chunk.css";
};